export default function Phase3() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Phase Header */}
        <div className="flex items-center justify-center mb-8">
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160517458/settings_images/c821fd2-60ad-dfbb-b7b-3c7076dbb748_0a9554db-dfc8-42b5-bbf2-fe0e7fe8eafe.png" 
            alt="Phase Icon" 
            className="w-16 h-16"
          />
        </div>

        <div className="max-w-4xl mx-auto text-left mb-12">
          <h4 className="text-xl font-bold text-gray-900 mb-2">
            <span>Phase 3:</span>
          </h4>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            <span>AI Image &amp; Graphic Creation</span>
          </h2>
        </div>

        {/* Image Examples */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/e07df99643ff15b7573e07a591b88937.jpeg" 
            alt="AI Generated Image" 
            className="w-full h-64 object-cover rounded-lg"
          />
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/adc867b337feb8eff13120749cf46a26.jpeg" 
            alt="AI Generated Image" 
            className="w-full h-64 object-cover rounded-lg"
          />
          <img 
            src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/b4622e49973c582b48eb6fbdca4948d7.jpeg" 
            alt="AI Generated Image" 
            className="w-full h-64 object-cover rounded-lg"
          />
        </div>

        <div className="max-w-5xl mx-auto text-center mb-12">
          <p className="text-base text-gray-700 mb-4">These images were all made completely with AI.</p>
          <p className="text-base text-gray-700 mb-4">It took seconds to generate each one.</p>
          <p className="text-base text-gray-700 mb-8">And in total it cost me less than 25 cents 😱 (no expensive monthly subscription required)</p>
        </div>

        <div className="max-w-5xl mx-auto mb-12">
          <div className="bg-white rounded-lg shadow-md p-8">
            <p className="text-base text-gray-700 mb-4"><strong>Imagine being able to create any image you want to use in your content.</strong></p>
            <p className="text-base text-gray-700 mb-2">❌ No expensive cameras or lighting equipment</p>
            <p className="text-base text-gray-700 mb-2">❌ No complex, expensive, &amp; technical software you need to master</p>
            <p className="text-base text-gray-700 mb-4">❌ No need to spend HOURS trying to get that "perfect" picture.</p>
            <p className="text-base text-gray-700"><span>The potential is out of this world!</span></p>
          </div>
        </div>

        {/* Category Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 gap-6 mb-12">
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/bada704-21c7-6e10-665c-83c5bb1ee0_5uLU7wBpRPKCFQRlivojA_4833c49edb3e4b998a53a8f0f63f843f.jpg" 
              alt="Fashion" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Fashion</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/e3eb0a7-a3c8-27d5-3ba-6ea004e6bf0_dUGRmgvN3DSG0gAiTcQ5V_a7b2ec55f706477381b4b90f3234a732.jpg" 
              alt="Wildlife" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Wildlife</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/f1b81e-d08-de5c-15c5-64ba5d3b315_f29b452d-b389-4d46-9065-f2d8a1a7414f.jpg" 
              alt="Animation" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Animation</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/8b20f3-f14c-4230-6fa5-c4bdce67061_55114f38-bb89-4a24-84ba-479db3e49924.jpg" 
              alt="Cartoons" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Cartoons</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/5c080f-712-8aeb-f5b-5c525a0c546_Sci-fi_2.jpg" 
              alt="Science Fiction" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Science Fiction</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/05b136b-4d-68a4-54eb-62a32771ab3d_landscape.jpg" 
              alt="Landscapes" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Landscapes</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/d7e52eb-c724-4884-7b78-6e6464daa23_bark_and_walk_logo.png" 
              alt="Logo Design" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Logo Design</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/830e52b-3e36-8453-4ea4-5df1acf23161_channel_banner.png" 
              alt="Channel Art" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Channel Art</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/41d4341-1563-7586-51ca-d884c23375d_AI_Income_grahpic.png" 
              alt="Infographics" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Infographics</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/f3c18e3-d272-1d37-528b-6037f187cb2_architecture.jpg" 
              alt="Architecture" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Architecture</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/72fbd5c-38af-8866-65dd-514d7ad1e5_fitness.jpg" 
              alt="Health & Wellness" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Health &amp; Wellness</h6>
          </div>
          <div className="text-center">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/36278a-4b15-c672-264c-f1b5888cd6_product_photo_2.png" 
              alt="Product Photos" 
              className="w-full h-48 object-cover rounded-lg mb-3"
            />
            <h6 className="text-lg font-semibold text-gray-900">Product Photos</h6>
          </div>
        </div>

        {/* Dog Example */}
        <div className="max-w-4xl mx-auto mb-12">
          <hr className="mb-8" />
          <h4 className="text-2xl font-bold text-gray-900 mb-8 text-left">
            <span>You can even turn your furry friend into a Pixar character!</span>
          </h4>
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/d134eb7-b8d5-ff10-e644-3a622344f0f_ollie_real.png" 
              alt="Real Dog" 
              className="w-full rounded-lg"
            />
            <img 
              src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/a0b848-0c81-b81d-e7e8-b6c2a5deed6c_Ollie_pixar.png" 
              alt="Pixar Dog" 
              className="w-full rounded-lg"
            />
          </div>
          <h4 className="text-2xl font-bold text-gray-900 mb-8 text-left">
            <span>Or maybe something a bit more fitting for your dog...</span>
          </h4>
          <img 
            src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/0d0dc82-6d02-fe0c-260c-addfef052f_Ollie_evil.png" 
            alt="Evil Dog" 
            className="w-full rounded-lg mb-12"
          />
        </div>

        {/* Graphics Section */}
        <div className="max-w-4xl mx-auto mb-12">
          <hr className="mb-8" />
          <h4 className="text-2xl font-bold text-gray-900 mb-12 text-left">
            <span>Skip Photoshop, create incredible graphics in seconds!</span>
          </h4>

          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <img 
                src="https://static.readdy.ai/image/1ee33a74a7d817227244af36e3fd2b0e/ac090e733dbe1b036a1fc10c2b48842e.jpeg" 
                alt="Professional Logos" 
                className="w-full mb-4 rounded-lg"
              />
              <h5 className="text-xl font-bold text-gray-900 mb-3">Professional Logos</h5>
              <p className="text-base text-gray-700">Struggling to come up with a design for your new logo? What if you could create 100 unique versions with AI to see what you really like? This will make finding that "perfect" logo infinitely easier. Not to mention you won't need to hire a professional graphic designer.</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <img 
                src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/2473505-3482-c4c-6d5b-f82a6ae3417a_AICC_poster_small_.png" 
                alt="Website Graphics" 
                className="w-full mb-4 rounded-lg"
              />
              <h5 className="text-xl font-bold text-gray-900 mb-3">Website Graphics</h5>
              <p className="text-base text-gray-700">The graphic above would normally take me 1-2 hours to create. AI made it for me in seconds. So much of this page that you're viewing right now was created with AI. This saved me hundreds of hours (and thanks to AI, I think this is one of our best looking pages ever!)</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <img 
                src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/888ff8e-0d2f-03a7-fde6-ae35b7aeaa_DFIxBMhYCEhRp173Fz68t_image.png" 
                alt="Channel Art" 
                className="w-full mb-4 rounded-lg"
              />
              <h5 className="text-xl font-bold text-gray-900 mb-3">Channel Art</h5>
              <p className="text-base text-gray-700">Most beginners spend DAYS stressing over the design for their youtube channel art. Most resort to hiring freelancers that cost hundreds of dollars. I just used AI to create this banner in seconds and it only cost 8 cents... 😱</p>
            </div>
            <div className="bg-white rounded-lg shadow-md p-6 text-center">
              <img 
                src="https://kajabi-storefronts-production.kajabi-cdn.com/kajabi-storefronts-production/file-uploads/themes/2160737798/settings_images/70dd7a3-e214-ab2a-1527-0cf1d2a240c6_Ai_facebook_ad.png" 
                alt="Product Marketing" 
                className="w-full mb-4 rounded-lg"
              />
              <h5 className="text-xl font-bold text-gray-900 mb-3">Product Marketing</h5>
              <p className="text-base text-gray-700">When you know the right tools to use. With the right prompt architecture, you can create professional facebook &amp; google ads in seconds... You can control every element of the image or you can let AI do all of the brainstorming!</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
